import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import ExportUtil from '../../../../common/ExportUtil';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

class Attachment extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
    }
    
    show = record => {
        this.setState({
            record,
            visible: true
        }, () => {
            this.loadedFileList(
                this.loadContractFileList(),
                // record.applyStatus !== 'Approval_Success' ?
                //     this.loadCurrentFileList()
                // :
                //     Promise.resolve([])
            );
        });
    }

    hide = () => {
        this.setState({
            data: [],
            visible: false,
        });
    }

    // 处理合同附件、当前附件
    loadedFileList = (...promises) => {
        Promise.all(promises).then(res => {
            // 兼容360
            const flat = [].flat ? [].flat : [].flatten;
            const data = flat.call(res || []);
            this.setState({ data });
        }).catch(error => {
            console.error(error);
        })
    }

    loadContractFileList = () => {
        const { record: { nationVerifySiteId } } = this.state;
        return Fetch.post(API_URL.nationalverification.queryEnclosureFileList, {
            relateId:nationVerifySiteId,
            uploadType:"NATION_VERIFY_SITE"
        }).then(res => {
            const fileList = res.datas || [];
            fileList.forEach((item, index) => {
                item.uid = item.id;
            });
            return fileList;
        });
    }

    // loadCurrentFileList = () => {
    //     const { record: { nationVerifySiteId } } = this.state;
    //     return Fetch.post(API_URL.nationalverification.queryEnclosureFileList, {
    //         relateId: nationVerifySiteId,
    //         fileType: 'NATION_VERIFY_SITE',
    //     }).then(res => {
    //         const fileList = res.data || [];
    //         fileList.forEach((item, index) => {
    //             item.uid = item.fileMateId;
    //         });
    //         return fileList;
    //     });
    // }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({fileMetaId: id}, null, url);
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 100,
    }, {
        title: '附件名称',
        dataIndex: 'name',
        key: 'name',
        width: 400,
        render: (text, record) => (
            <a onClick={e => this.downLoadFile(e, record.fileMateId)}>{text}</a>
        )
    }]

    render () {
        const { visible, loading, record, data } = this.state;
        const { nationVerifyNumber } = record;
        return (
            <Modal
                title="查看附件"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="560px"
                footer={<Button type="primary" onClick={this.hide}>关 闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        国家核查编号: {nationVerifyNumber}
                    </div>
                    <TableC
                        columns={this.getColumns()}
                        data={data}
                        scrollY={270}
                        loading={loading}
                        className="attachment"
                    />
                </div>
            </Modal>
        );
    }
}

export default Attachment;



// WEBPACK FOOTER //
// ./src/components/qualityManagement/Nationalverification/components/Attachment.js